import { render, staticRenderFns } from "./imaged-object-editor-toolbar.vue?vue&type=template&id=37521224&scoped=true&"
import script from "./imaged-object-editor-toolbar.vue?vue&type=script&lang=ts&"
export * from "./imaged-object-editor-toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./imaged-object-editor-toolbar.vue?vue&type=style&index=0&id=37521224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37521224",
  null
  
)

export default component.exports